module.exports = (message) => {
  const errorMessageNode = document.querySelector('.notification--error')
  if (errorMessageNode) errorMessageNode.innerHTML = message
}
